/**
 * Border + background tint for the destructive / warning card variants.
 *
 * Tint only — no radius, no padding — so every card that offers these variants
 * (ObjectCard, TaskCard) shares one definition of the tokens while keeping its
 * own shape. Each card's `default` variant stays local: the defaults differ on
 * purpose.
 *
 * Kept in its own module (not exported from ObjectCard.tsx) so the component
 * file exports only components (react-refresh/only-export-components).
 */
export const CARD_VARIANT_TINT_CLASSES = {
  destructive: 'border border-utility-error-200 bg-utility-error-50',
  warning: 'border border-utility-warning-200 bg-utility-warning-50',
} as const;
